import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from './components/Footer';
import Header from './components/Header';
import { ActiveNavBarProvider } from './context/ActiveNavBarProvider';
import Expertise from "./pages/expertise/Expertise";
import WebDevelopment from "./pages/expertise/webDevelopment/WebDevelopment";
import MobileDevelopment from "./pages/expertise/mobileDevelopment/MobileDevelopment";
import ArtificialIntelligenceExpertise from "./pages/expertise/artificialIntelligenceExpertise/ArtificialIntelligenceExpertise";
import Services from "./pages/services/Services";
import DevelopmentCenterServices from "./pages/services/developmentCenterServices/DevelopmentCenterServices";
import ExtendedTeamServices from "./pages/services/extendedTeamServices/ExtendedTeamServices";
import BusinessConsulting from "./pages/services/it_BusinessConsulting/BusinessConsulting";
import ContactUs from "./pages/contactUs/ContactUs";
import CaseStudies from "./pages/caseStudies/CaseStudies";
import Blog from "./pages/blog/Blog";
import WhyUs from "./pages/whyUs/WhyUs";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import Team from "./pages/team/Team";
import Careers from "./pages/careers/Careers";
import Home from "./pages/home/Home";
import Product from "./pages/product/Product";
import RDRental from "./pages/product/RDRental";
import ChurchDirectory from "./pages/product/ChurchDirectory";
import POSSystem from "./pages/product/POSSystem";
import JjEve from "./pages/product/JjEve";
import DataRepoCustomSolution from "./pages/blog/DataRepoCustomSolution";
import NaturalLanguageProcessing from "./pages/expertise/artificialIntelligenceExpertise/NaturalLanguageProcessing";
import SentimentAnalysis from "./pages/expertise/artificialIntelligenceExpertise/SentimentAnalysis";
import ModelTraining from "./pages/expertise/artificialIntelligenceExpertise/ModelTraining";
import RentalSoftware from "./pages/caseStudies/RentalSoftware";
import Churchdirectory from "./pages/caseStudies/ChurchDirectory";
import PosSystem from "./pages/caseStudies/POSSystem";
import EventManagementsystem from "./pages/caseStudies/EventManagementSystem";
import ScrollToTop from "./components/ScrollToTop";
import LTI from "./pages/blog/LTI";
import NLP from "./pages/blog/NLPText";
import DeveloperSyndrome from "./pages/blog/DeveloperSyndrome";
import DataRepoMostRecommended from "./pages/blog/DataRepoMostRecommended";
import DataRepoSoftwareRewind from "./pages/blog/DataRepoSoftwareRewind";
import ChatgptReplaceHuman from "./pages/blog/ChatgptReplaceHuman";
import CeclModel from "./pages/blog/CeclModel";
import DatasetCollectionForAi from "./pages/blog/DatasetCollectionForAi";
import JjKit from "./pages/product/JjKit";
import JjTimesheet from "./pages/product/JjTimesheet";
import AiPoweredChatbots from "./pages/blog/AiPoweredChatbots";
import AiCybersecurity from "./pages/blog/AiCybersecurity";
import AiAgentsDecisionMakers from "./pages/blog/AiAgentsDecisionMakers";
import ImpactOfAIAgents from "./pages/blog/ImpactOfAIAgents";
import AiWebFormValidation from "./pages/blog/AiWebFormValidation";
import SecuringiotDevices from "./pages/blog/SecuringiotDevices";
import AiEverydayLife from "./pages/blog/AiEverydayLife";
import RevolutionizeMobileConnectivity from "./pages/blog/RevolutionizeMobileConnectivity";
import ProjectManagement from "./pages/caseStudies/ProjectManagement";
import Crm from "./pages/caseStudies/Crm";
import Timesheet from "./pages/caseStudies/Timesheet";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ActiveNavBarProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Product />} />
          <Route path="/products/rd-rental" element={<RDRental />} />
          <Route path="/products/church-directory" element={<ChurchDirectory />} />
          <Route path="/products/pos-system" element={<POSSystem />} />
          <Route path="/products/jj-eve" element={<JjEve />} />
          <Route path="/products/jj-kit" element={<JjKit />} />
          <Route path="/products/jj-timesheet" element={<JjTimesheet />} />
          <Route path="/expertise" element={<Expertise />} />
          <Route path="/expertise/web-development" element={<WebDevelopment />} />
          <Route path="/expertise/mobile-development" element={<MobileDevelopment />} />
          <Route path="/expertise/artificial-intelligence-expertise" element={<ArtificialIntelligenceExpertise />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/it-business-consulting" element={<BusinessConsulting />} />
          <Route path="/services/development-center-services" element={<DevelopmentCenterServices />} />
          <Route path="/services/extended-team-services" element={<ExtendedTeamServices />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/data-repo-custom-solution" element={<DataRepoCustomSolution />} />
          <Route path="/blog/lti-integration-for-lms-systems" element={<LTI />} />
          <Route path="/blog/nlp-text-classification" element={<NLP />} />
          <Route path="/blog/developer-syndrome" element={<DeveloperSyndrome />} />
          <Route path="/blog/data-repo-most-recommended-company" element={<DataRepoMostRecommended />} />
          <Route path="/blog/data-repo-software-clutch-rewind" element={<DataRepoSoftwareRewind />} />
          <Route path="/blog/can-chatgpt-replace-human-work" element={<ChatgptReplaceHuman />} />
          <Route path="/blog/cecl-model-risk-application" element={<CeclModel />} />
          <Route path="/blog/new-datasets-to-train-ai" element={<DatasetCollectionForAi />} />
          <Route path="/blog/ai-powered-chatbots" element={<AiPoweredChatbots />} />
          <Route path="/blog/ai-cybersecurity" element={<AiCybersecurity />} />
          <Route path="/blog/ai-agents-decision-makers" element={<AiAgentsDecisionMakers />} />
          <Route path="/blog/impact-of-ai-agents" element={<ImpactOfAIAgents />} />
          <Route path="/blog/ai-web-form-validation" element={<AiWebFormValidation />} />
          <Route path="/blog/securing-iot-devices" element={<SecuringiotDevices />} />
          <Route path="/blog/ai-powered-tools-for-everyday-life" element={<AiEverydayLife />} />
          <Route path="/blog/revolutionize-mobile-connectivity" element={<RevolutionizeMobileConnectivity />} />

          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/team" element={<Team />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/natural-language-processing" element={<NaturalLanguageProcessing />} />
          <Route path="/sentiment-analysis" element={<SentimentAnalysis />} />
          <Route path="/model-training" element={<ModelTraining />} />
          <Route path="/case-studies/rental-software" element={<RentalSoftware />} />
          <Route path="/case-studies/church-directory" element={<Churchdirectory />} />
          <Route path="/case-studies/pos-system" element={<PosSystem />} />
          <Route path="/case-studies/event-management-system" element={<EventManagementsystem />} />
          <Route path="/case-studies/project-management-system" element={<ProjectManagement />} />
          <Route path="/case-studies/crm" element={<Crm />} />
          <Route path="/case-studies/time-sheet" element={<Timesheet />} />
        </Routes>
        <Footer />
      </ActiveNavBarProvider>
    </Router>
  );
}

export default App;
